



















































import { log } from '@/log'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { BrandService } from '@/services/api/brand'
import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

import { InstanceResolver } from '@/util/instanceResolver'
import { SelectItem } from '@spa/components/atoms/model/SelectItem'
import { InquiryDetail, InquiryKind } from './model/InquiryKind'

interface BrandState {
  list: SelectItem[]
  status: 'prepare' | 'complete' | 'error'
}

@Component
export default class InputFormKindDropdown extends Vue {
  @Inject()
  $validator: Validator

  @Prop({ required: true })
  kindLabels: InquiryKind[]

  @Prop({ required: true })
  kind: string | null

  @Prop({ required: true })
  detail: string | null

  @Prop({ required: true })
  brand: string | null

  @Prop({ default: true })
  modifiable: boolean

  @Prop({ required: true })
  input: (value: string, field: string) => void

  @Prop({ default: () => new BrandService() })
  brandListGateway: BrandService

  brandState: BrandState = {
    list: [],
    status: 'prepare',
  }

  created() {
    this.initializeBrandList()
  }

  get isMulti(): boolean {
    return InstanceResolver.isMulti()
  }

  get selectedKind(): InquiryKind {
    // 種類が明示されてなければ最初のを選ぶ
    return this.kindLabels.find(
      kind => kind.value === this.kind
    ) || this.kindLabels[0]
  }

  get selectedDetail(): InquiryDetail {
    return this.selectedKind.details.find(
      detail => detail.value === this.detail
    ) || this.selectedKind.details[0]
  }

  get kindText(): string {
    return this.selectedKind.text
  }

  get detailText(): string {
    return this.selectedDetail.text
  }

  get kindList(): SelectItem[] {
    return this.kindLabels.map(kind => ({
      value: kind.value,
      text: kind.text,
      selected: kind.value === this.kind,
      disabled: kind.disabled,
    }))
  }

  get detailList(): SelectItem[] {
    return this.selectedKind.details.map(detail => ({
      value: detail.value,
      text: detail.text,
      selected: detail.value === this.detail,
      disabled: detail.disabled,
    }))
  }

  get brandList(): SelectItem[] {
    return this.brandState.list
  }
  get brandStateIsError(): boolean {
    return this.brandState.status === 'error'
  }

  private async initializeBrandList() {
    const result = await this.brandListGateway.list()

    const brandList = result.fold(
      (error) => {
        log.error({ error })

        this.brandState.status = 'error'

        return []
      },
      (response) => {
        this.brandState.status = 'complete'

        return response.body.data.map(brand => ({
          text: brand.name,
          value: brand.name,
        }))
      }
    )

    const behaviorConfig = new BehaviorConfig()
    const etcValue = behaviorConfig.groupLabel

    this.brandState.list = [
      {
        text: 'ブランドを選択してください',
        value: '',
        disabled: true,
        selected: true,
      },
      ...brandList,
      {
        text: 'その他',
        value: etcValue,
      },
    ]
  }
}
